<template>
  <div class="order-block order-basic" id="baseInsuranceInfo">
    <div class="title">基本信息</div>

    <el-form :model="insuranceData" ref="dataForm" :rules="rules" :inline="true" label-position="top">
      <div class="content">
        <el-form-item label="" prop="insure">
          <div class="form-item-label" solt="label">
            投保类型<span class="required">*</span>
          </div>
          <el-select :value="insuranceData.insurance_type_id " placeholder="请选择" @input="changeInsuranceType">
            <el-option label="企业投保" :value="1" v-if="insuranceTypeCompany"></el-option>
            <el-option label="个人投保" :value="0" v-if="insuranceTypePersonal"></el-option>
          </el-select>
        </el-form-item>

        <!-- 企业投保 -->
        <el-form-item label="" prop="insure" v-if="currentInsuranceTypeIsCompany">
          <div class="form-item-label" solt="label">
            选择投保人<span class="required">*</span><span v-if="insuranceData.for_who === 0" class="sub-label">(默认投保人为深圳市六六六国际旅行社有限公司)</span>
          </div>
          <el-select :value="insuranceData.for_who" placeholder="请选择" @input="changeForWho">
            <el-option label="默认投保人" :value="0"></el-option>
            <el-option label="指定投保人" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="" prop="start_date">
          <div class="form-item-label" solt="label">
            起保日期<span class="required">*</span>
          </div>
          <el-date-picker v-model="insuranceData.start_date" format="yyyy年MM月dd日" placeholder="请选择"
            :editable="false" type="date" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="" prop="protect_days">
          <div class="form-item-label" solt="label">
            保障天数<span class="required">*</span>
          </div>
          <el-select v-model="insuranceData.protect_days" placeholder="请选择" @change="calculatePrice">
            <el-option v-for="(value, index) in insuranceData.insure_date_range" :key="index"
              :label="value.value + value.unit" :value="value.value + value.unit"></el-option>
          </el-select>
          <div class="subtitle" v-if="calculateEndDate()">终保日期：{{calculateEndDate()}}</div>
        </el-form-item>
        <template v-if="insuranceData.destinations">
          <el-form-item label="" prop="destination" v-if="insuranceData.destinations.length">
            <div class="form-item-label" solt="label">
              旅行目的地<span class="required">*</span><span class="sub-label">(如有多个国家，选择一个即可)</span>
            </div>
            <el-select v-model="insuranceData.destination" placeholder="请选择" :filterable="true">
              <el-option :label="value.cName" :value="value.cName" v-for="(value, index) in insuranceData.destinations" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="destination" v-else>
            <div class="form-item-label" solt="label">
              旅行目的地<span class="required">*</span><span class="sub-label">(如有多个国家，选择一个即可)</span>
            </div>
            <el-select v-model="insuranceData.destination" placeholder="请选择" :filterable="true">
              <el-option :label="value" :value="value" v-for="(value, index) in countryList" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="" prop="email">
          <div class="form-item-label" solt="label">
            邮箱<span class="required">*</span><span class="sub-label">(投保成功后，电子保单将发送至该邮箱)</span>
          </div>
          <el-input v-model.trim="insuranceData.email" placeholder="请输入" :maxlength="50"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>


<script>
import moment from 'moment';
import countryList from '@/datas/country';
import insuranceInfoService, { rules } from '@/pages/insurance/services/insurance-info-service';
import utils from '@/libs/utils';


export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rules,
      countryList,
      insuranceData: undefined,
    };
  },
  computed: {
    pickerOptions() {
      const first_date = this.insuranceData.first_date || 0;
      const max_date = this.insuranceData.max_date || 365;
      return { // 日期选择控件配置
        disabledDate(time) {
          return (time.getTime() < (Date.now() + (first_date - 1) * 86400000)) ||
          (time.getTime() > (Date.now() + (max_date) * 86400000));
        },
      };
    },
    // 投保类型
    insuranceTypeCompany() {
      // 0个人 1公司
      return this.insuranceData.insurance_type_set && this.insuranceData.insurance_type_set.includes(1);
    },
    insuranceTypePersonal() {
      // 0个人 1公司
      return this.insuranceData.insurance_type_set && this.insuranceData.insurance_type_set.includes(0);
    },
    // 当前选中的投保类型
    currentInsuranceTypeIsCompany() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 1;
    },
    currentInsuranceTypeIsPersonal() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 0;
    },

  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.insuranceData)) {
          this.insuranceData = utils.deepCopy(val);
        }
      },
      deep: true,
      immediate: true,
    },
    insuranceData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    changeInsuranceType(value) {
      if (this.insuranceData.insurance_type_id === value) return;
      this.insuranceData.insurance_type_id = value;
      this.insuranceData.for_who = 0;
      // 清空投保人信息
      this.insuranceData.applicant = { sex: '' };
    },
    changeForWho(value) {
      if (this.insuranceData.for_who === value) return;
      this.insuranceData.for_who = value;
      // 切换到指定，清空选择
      if (this.currentInsuranceTypeIsCompany && value === 1) {
        this.insuranceData.applicant = { sex: '' };
      } else if (this.currentInsuranceTypeIsPersonal && value === 0) {
        this.insuranceData.insurants = [{ sex: '' }];
      }
    },
    // 根据选项计算保险金额
    async calculatePrice() {
      try {
        const { single_price, original_price } = await insuranceInfoService.calculatePrice(this.insuranceData);
        this.insuranceData.single_price = single_price;
        this.insuranceData.original_price = original_price;
      } catch (e) {
        console.log('eeeee', e);
      }
      // const { case_code, travel_delays, protect_days, insurant_age } = this.insuranceData;
      // if (!protect_days) return;// //////-------------更改部分
      // const params = { case_code, travel_delays, protect_days, insurant_age };
      // if (protect_days === '1年') {
      //   params.protect_days = '365天';
      // } else if (protect_days.indexOf('1年') > -1 && protect_days.length > 2) {
      //   params.protect_days = '365天';
      //   params.extended = protect_days;
      // } else {
      //   params.protect_days = protect_days;
      // }
      // insuranceApi.insuranceSimpleTrial(params).then((data) => {
      //   this.insuranceData.single_price = data.single_price;
      //   this.insuranceData.original_price = data.original_price;
      // }).catch((e) => {
      //   if (e) console.log(e);
      // });
    },
    // 计算终保日期
    calculateEndDate() {
      const { protect_days, start_date } = this.insuranceData;
      let proDays = 0;
      const regObj1 = /\d+/;
      const regObj2 = /-(\d+)/;
      if (protect_days && start_date) {
        if (protect_days.indexOf('-') > -1) {
          proDays = parseInt(regObj2.exec(protect_days)[1], 10);
        } else if (protect_days.indexOf('月') > -1) {
          proDays = this.calMonthDates(start_date, parseInt(regObj1.exec(protect_days)[0], 10));
        } else if (protect_days.indexOf('1年') > -1) {
          proDays = 365;
        } else {
          proDays = parseInt(regObj1.exec(protect_days)[0], 10);
        }
        this.insuranceData.end_date = moment(start_date).add(proDays - 1, 'day').format('YYYY-MM-DD');
        return moment(start_date).add(proDays - 1, 'day').format('YYYY年M月D日');
      }
      return '';
    },
    validate() {
      console.log('起保日期==========', this.insuranceData.start_date);
      return new Promise((resolve, reject) => {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject('#baseInsuranceInfo'); // 抛id出去，做滚动
          }
        });
      });
    },


  },

};
</script>


<style lang="less" scoped>
.order-block {
  .title{
    padding-left: 24px;
    display: flex;
    align-items: center;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
    height: 44px;
    color: #2F333D;
    font-size: 18px;
    font-weight: 600;
    &.personal {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 24px;
      .self-btn {
        font-size: 14px;
        color: #5F666E;
        line-height: 20px;
        font-weight: normal;
        display: flex;
        align-items: center;
        /deep/ .el-switch {
          transform: scale(0.7);
          margin-right: 2px;
        }
      }
    }
  }
  .content {
    padding: 20px 24px;
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
    &.self-insure-content {
      display: flex;
      flex-direction: column;
      .applicant-list {
        display: flex;
        flex-wrap: wrap;
        .applicant-item {
          padding: 0 46px;
          height: 28px;
          line-height: 28px;
          background: #FAFBFC;
          border-radius: 2px;
          border: 1px solid #DEE2E6;
          margin-right: 16px;
          font-size: 14px;
          color: #2F333D;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/base-insurance-info.vue